'use client'

import Avatar from '@component/avatar'
import AgentEmailButton from '@component/card/agent/button/email'
import AgentPhoneButton from '@component/card/agent/button/phone'
import OfficeLine from '@component/card/agent/officeLine'
import AgentReviewStar from '@component/reviewStar'
import { agentDataLayer } from '@plugin/google/gtm/modules/agent'
import { agencyDetail } from '@router'
import { getColliersClassName, showReview } from '@utils'
import classNames from 'classnames'
import DisablePrefetchLink from '@component/disablePrefetchLink'
import { Suspense } from 'react'
import AgentSaleTotals from '../../saleTotals'
import { ReviewButton } from './button'

export default function AgentInfoCard({
  data
}) {

  return (
    <div>
      <div className='w-90 h-90 md:w-156 md:h-156 md:mx-auto'>
        <Avatar
          src={data.icon}
          alt={data.name}
          width={156}
          height={156}
          className={classNames('border-4 border-white shadow-md max-w-full max-h-full', getColliersClassName(data.office))}
          circle
          defaultIcon='icon-avatar'
          iconSize='!text-3xl'
          fetchPriority='high'
        ></Avatar>
      </div>
      <h1 className='hidden'>{data.name}, {data.jobTitle}</h1>
      <div className='mt-24 text-font text-3xl font-bold md:text-center'>{data.name}</div>
      <div className='mt-8 text-neutral-5 text-lg md:text-center'>{data.jobTitle}</div>
      {data.rateStat && showReview(data) && <AgentReviewStar score={data.rateStat.avgScore} count={data.rateStat.reviewCount} className='mt-8 md:justify-center'></AgentReviewStar>}
      <AgentSaleTotals data={data} className='mt-20 grid grid-cols-2 gap-y-26 gap-x-10 md:hidden'></AgentSaleTotals>
      <div className='mt-20 space-y-10'>
        <Suspense>
          {
            showReview(data) && <ReviewButton data={data}></ReviewButton>
          }
        </Suspense>
        <AgentPhoneButton agent={data} data={data.phoneNumber} icon className='!px-30' onClick={agentDataLayer.phoneClick}></AgentPhoneButton>
        <AgentEmailButton data={data} icon className='!px-30' onClick={agentDataLayer.emailClick}></AgentEmailButton>
        <OfficeLine data={data.office} bgColor={data.bgColor} iconHeight={24} center className='!h-40 rounded-sm'></OfficeLine>
        <DisablePrefetchLink href={agencyDetail(data.office)} className='text-primary text-xs text-center block !mt-20'>{data.office.name}</DisablePrefetchLink>
      </div>
    </div>
  )
}